import { ResolverTag } from '@ps/web-core-enums';
import type { TranslationTag } from '@ps/web-core-intl';
import { StarsButton, Translation, useResolver } from '@ps/web-shared-components';
import React from 'react';

import PokerStarsIcon from '@swf/account/src/assets/pokerstars-mobile-logo.svg';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import powerPath from '../../assets/lobbies/power_path_small.jpg';
import spinAndGo from '../../assets/lobbies/spin_and_go_small.jpg';

import {
  TXTCLI_Coming_soonX_1,
  TXTCLI_Explore_other_games_in_the_bro_ELL,
  TXTMOB_Download_PokerStars
} from './ComingSoonPage.messages.json';
import styles from './ComingSoonPage.scss';

interface Props {
  description: TranslationTag;
}

const IMAGE_DATA = [
  { resolver: ResolverTag.PowerPathLobby, alt: 'Power Path', src: powerPath },
  { resolver: ResolverTag.SaGLobby, alt: 'Spin and Go', src: spinAndGo }
];

const ComingSoonPage: React.FC<Props> = ({ description }) => {
  const downloadLink = useResolver(ResolverTag.PSDownload);

  return (
    <div className={styles.container}>
      <div className={styles.comingSoon}>
        <Translation {...TXTCLI_Coming_soonX_1} />
      </div>
      <div className={styles.descriptionMessage}>
        <Translation {...description} />
      </div>
      <PokerStarsIcon className={styles.pokerStarsIcon} />
      <StarsButton
        href={downloadLink}
        variant="primary"
        className={styles.button}
        disabled={!downloadLink}
        translation={TXTMOB_Download_PokerStars}
      />
      <div className={styles.exploreMessage}>
        <Translation {...TXTCLI_Explore_other_games_in_the_bro_ELL} />
      </div>
      <div className={styles.imagesContainer}>
        {IMAGE_DATA.map((image) => (
          <ResolverLink key={image.alt} resolverTag={image.resolver} target="_self">
            <img src={image.src} alt={image.alt} className={styles.image} />
          </ResolverLink>
        ))}
      </div>
    </div>
  );
};

export default ComingSoonPage;
